import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, DoBootstrap, Injector, NgModule, Type } from '@angular/core';

import { createCustomElement } from '@angular/elements';
import { provideHttpClient, withJsonpSupport } from '@angular/common/http';
import { AmplifyModules, AmplifyService } from 'aws-amplify-angular';
import { Auth } from 'aws-amplify';

const ELEMENTS = {
	'frametoday-item-images': () => import('./item-images/item-images.component').then(m => m.ItemImagesComponent),
	'frametoday-cart-icon': () => import('./cart-icon/cart-icon.component').then(m => m.CartIconComponent),
	'frametoday-cart-add': () => import('./cart-add/cart-add.component').then(m => m.CartAddComponent),
	'frametoday-checkout': () => import('./checkout/checkout.component').then(m => m.CheckoutComponent),
	'frametoday-signin': () => import('./signin/signin.component').then(m => m.SigninComponent),
	'frametoday-signup': () => import('./signup/signup.component').then(m => m.SignupComponent),
	'frametoday-cart': () => import('./cart/cart.component').then(m => m.CartComponent),
	'frametoday-reviews': () => import('./reviews/reviews.component').then(m => m.ReviewsComponent),
	'frametoday-opening-hours': () => import('./opening-hours/opening-hours.component').then(m => m.OpeningHoursComponent),
	'frametoday-store-map': () => import('./map/store-map.component').then(m => m.StoreMapComponent),
	'frametoday-store-finder': () => import('./store-finder/store-finder.component').then(m => m.StoreFinderComponent),
	'frametoday-items': () => import('./items/items.component').then(m => m.ItemsComponent),
	'frametoday-search': () => import('./search/search.component').then(m => m.SearchComponent),
	'frametoday-contact-form': () => import('./contact-form/contact-form.component').then(m => m.ContactFormComponent),
	'frametoday-klaviyo-form': () => import('./klaviyo-form/klaviyo-form.component').then(m => m.KlaviyoFormComponent),
	'frametoday-print-and-frame': () => import('./print-and-frame/print-and-frame.component').then(m => m.PrintAndFrameComponent),
	'frametoday-youtube': () => import('./youtube/youtube.component').then(m => m.YoutubeComponent),
}

const ELEMENT_COMPONENTS = [
]

@NgModule({
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	imports: [
		BrowserModule,
		ELEMENT_COMPONENTS,
	],
	providers: [
		provideHttpClient(withJsonpSupport()),
		{
			provide: AmplifyService,
			useFactory: () => {
				return AmplifyModules({
					Auth
				});
			}
		},
	],
})
export class AppModule implements DoBootstrap {

	constructor(
		private injector: Injector,
		private amplify: AmplifyService,
	) { }

	loaded = new Set();

	loadAndDefine(tag: string) {
		if (this.loaded.has(tag)) return;
		this.loaded.add(tag);

		ELEMENTS[tag]().then((component: Type<any>) => {
			const customElement = createCustomElement(component, { injector: this.injector });
			customElements.define(tag, customElement);
		});
	}

	mutationObserver = new MutationObserver(muts => {
		muts.forEach(m => {
			m.addedNodes.forEach(node => {
				if (node.nodeType === 1) {
					const tag = (node as HTMLElement).tagName.toLowerCase();
					if (ELEMENTS[tag]) {
						this.loadAndDefine(tag);
					}
				}
			});
		});
	});

	scanForElements() {
		Object.keys(ELEMENTS).forEach(tag => {
			if (document.querySelector(tag)) {
				this.loadAndDefine(tag);
			}
		});
	}

	ngDoBootstrap() {

		this.scanForElements();

		document.addEventListener('DOMContentLoaded', () => {
			this.scanForElements();
		});

		this.mutationObserver.observe(document.documentElement, { childList: true, subtree: true });
	}

}
